// 리뷰 사진 줄(Yotpo)을 브라우저 기본 가로 스크롤로 그린다.
//
// 앱은 뷰포트의 가로 넘침을 막아 두고 손가락을 직접 받아 좌표를 계산한 뒤 transform 을
// 다시 쓴다. 매 프레임 자바스크립트를 타므로 기기가 느리면 손가락보다 늦게 따라온다.
// 브라우저 기본 스크롤은 별도 스레드에서 처리돼 자바스크립트가 밀려도 끊기지 않는다.
//
// 여기는 앱이 그리는 영역이다. 우리 코드가 아니므로 손대기 전에 기대한 구조인지
// 확인하고, 하나라도 어긋나면 아무것도 하지 않는다. 앱이 바뀌었을 때 최악이
// "개선이 사라짐" 에서 멈추게 하는 장치다.
//
// 되돌릴 길을 남긴다 — 주소에 ?yotpo-carousel=1 을 붙이면 앱 기본 동작을 탄다.
//
// 확대 뷰(사진을 눌렀을 때 뜨는 큰 화면)는 건드리지 않는다. 거기는 사진과 리뷰 글이
// 한 몸이라 스크롤로 바꾸면 둘이 어긋난다. 실측으로 확인했고, 모달이 리뷰 줄 바깥에
// 있어 선택자를 줄 안쪽으로 좁히는 것만으로 분리된다.
(function () {
  'use strict';

  function 되돌리나() {
    try {
      return new URLSearchParams(window.location.search).get('yotpo-carousel') === '1';
    } catch (error) {
      return false;
    }
  }

  if (되돌리나()) return;

  var 줄선택자 = '.yotpo-media-gallery-container';

  // 앱 구조가 기대한 모양인지 본다. 아니면 null 을 돌려 아무것도 하지 않게 한다.
  function 점검(줄) {
    if (!줄) return null;
    var 뷰 = 줄.querySelector('.carousel__viewport');
    var 트랙 = 줄.querySelector('.carousel__track');
    if (!뷰 || !트랙) return null;

    // 이미 브라우저 스크롤이면 손댈 이유가 없다(앱이 스스로 바꿨을 수 있다).
    if (getComputedStyle(뷰).overflowX !== 'hidden') return null;
    if (getComputedStyle(트랙).display !== 'flex') return null;
    // 위치를 JS 로 옮기는 구조라는 표식. 이게 없으면 우리가 아는 캐러셀이 아니다.
    if (!/translateX\(/.test(트랙.style.transform || '')) return null;

    var 장 = 트랙.querySelectorAll(':scope > .carousel__slide');
    if (장.length < 2) return null;
    // 넘치지 않으면 스크롤할 것도 없다(데스크톱은 사진이 다 보인다).
    if (뷰.scrollWidth <= 뷰.clientWidth) return null;

    var 화살표 = [];
    var 버튼 = 줄.querySelectorAll('button');
    for (var i = 0; i < 버튼.length; i++) {
      if (!/thumbnail/.test(버튼[i].className)) 화살표.push(버튼[i]);
    }
    if (화살표.length !== 2) return null;

    return { 뷰: 뷰, 트랙: 트랙, 장: 장, 화살표: 화살표 };
  }

  function 스타일넣기() {
    if (document.getElementById('yotpo-native-style')) return;
    var style = document.createElement('style');
    style.id = 'yotpo-native-style';
    // 선택자를 리뷰 줄 안쪽으로 좁힌다. 확대 뷰의 캐러셀은 같은 클래스를 쓰지만
    // 모달이 이 컨테이너 밖에 있어 여기 걸리지 않는다.
    style.textContent =
      // text-size-adjust: iOS Safari 가 스크롤 컨테이너 안 글자를 스스로 키우는 것을 막는다.
      // 근거는 global.js 의 .native-slider 주석과 같다.
      줄선택자 + ' .carousel__viewport{overflow-x:auto!important;' +
      'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;' +
      '-webkit-text-size-adjust:100%;text-size-adjust:100%;}' +
      줄선택자 + ' .carousel__viewport::-webkit-scrollbar{display:none;}' +
      줄선택자 + ' .carousel__track{transform:none!important;width:auto!important;}' +
      줄선택자 + ' .carousel__slide{scroll-snap-align:start;}';
    document.head.appendChild(style);
  }

  // 앱의 화살표는 위치를 transform 으로 옮긴다. 그 길을 막았으니 눌러도 화면이
  // 움직이지 않는다. 우리가 클릭을 받아 스크롤로 대신 처리한다.
  function 화살표잇기(부품) {
    var 뷰 = 부품.뷰;
    var 장 = 부품.장;
    // 한 칸 = 옆 장까지의 거리. 앱이 정한 폭·간격을 그대로 따른다.
    function 한칸() {
      if (장.length < 2) return 뷰.clientWidth;
      var 거리 = 장[1].offsetLeft - 장[0].offsetLeft;
      return 거리 > 0 ? 거리 : 뷰.clientWidth;
    }

    var 왼쪽 = 부품.화살표[0];
    var 오른쪽 = 부품.화살표[1];
    // 왼쪽/오른쪽은 클래스명이 아니라 실제 위치로 가른다. 앱이 클래스명을 바꿔도
    // 방향을 잘못 잡지 않는다.
    if (왼쪽.getBoundingClientRect().left > 오른쪽.getBoundingClientRect().left) {
      var 잠시 = 왼쪽; 왼쪽 = 오른쪽; 오른쪽 = 잠시;
    }

    function 붙이기(버튼, 방향) {
      버튼.addEventListener('click', function (event) {
        // 앱 처리기가 뒤이어 transform 을 만지지 않도록 여기서 끊는다.
        event.preventDefault();
        event.stopPropagation();
        뷰.scrollBy({ left: 방향 * 한칸(), behavior: 'smooth' });
      }, true);
    }
    붙이기(왼쪽, -1);
    붙이기(오른쪽, 1);
  }

  function 적용(줄) {
    // 구조가 다르면 손대지 않는다. 앱 기본 동작이 그대로 남는다.
    var 부품 = 점검(줄);
    if (!부품) return false;
    스타일넣기();
    화살표잇기(부품);
    return true;
  }

  // 리뷰 줄은 앱이 나중에 그린다. 나타나면 한 번 적용하고 관찰을 끝낸다.
  function 기다렸다적용() {
    var 줄 = document.querySelector(줄선택자);
    if (줄 && 적용(줄)) return;

    var 관찰 = new MutationObserver(function () {
      var 지금 = document.querySelector(줄선택자);
      if (지금 && 적용(지금)) 관찰.disconnect();
    });
    관찰.observe(document.body, { childList: true, subtree: true });
    // 끝내 안 나타나면 관찰을 놓아준다. 리뷰가 없는 상품도 있다.
    setTimeout(function () { 관찰.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', 기다렸다적용, { once: true });
  } else {
    기다렸다적용();
  }
})();
